export function getRteContent(content: string, isTargetBlank = true) {
  if (content && content.length > 0) {
    // weird layout bug on mobile
    content = content.replace(/&nbsp;/g, ' ');

    if (isTargetBlank) {
      content = content.replace(/href=/g, 'target="_blank" href=');
    }

    // link parsing
    const regex = /href=".*?"/g;
    let regexMatch;
    while ((regexMatch = regex.exec(content)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (regexMatch.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      regexMatch.forEach(match => {
        const url: string = match.replace('href="', '').replace('"', '');
        const isValid = isValidUrl(url);

        // If URL is safe but not absolute, add http:// prefix
        if (isValid && !url.match(/^(https?:\/\/|#|mailto:|tel:|file:)/i)) {
          const newHref = `http://${url}`;
          content = content.replace(match, match.replace(url, newHref));
        }
        // If URL is not safe, remove the href attribute entirely
        else if (!isValid && url.length > 0) {
          content = content.replace(match, 'href=""');
        }
      });
    }
  }
  return content;
}

export function isValidUrl(url?: string): boolean {
  if (!url) return false;
  return /^\s*(#|\/|\.\/|\.\.\/|https?:\/\/|mailto:|tel:|file:|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/i.test(url);
}
